'use strict';

angular.module('marketController', [])

.controller('MarketController', ['$scope', '$rootScope', '$log', '$q','$routeParams','$location',
    function ($scope, $rootScope, $log, $q, $routeParams,$location) {    
    
    //Check auth credentials
    var currentUser = $rootScope.currentUser
    , ekey = currentUser.authdata
    , name = currentUser.name
    , today = moment().unix()
    ;

    $rootScope.header.show = false;
    $scope.page = 'market';
}])

;